import styled from "styled-components";

export const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  text-align: ${({ textAlign = "left" }) => textAlign};
  max-width: 600px;
`;
